// Image Category Setting Enums - Based on GS1 Product Image Specification

// Image Type - Based on GS1 IMAGE_TYPE_MAPPING
const IMAGE_TYPE = {
  // Primary Images (Section 3)
  A: 'Product Image (web) primary image',
  B: 'Product Image with Supporting Elements (web)',
  C: 'Product Image (High Resolution)',
  D: 'Product Image with Supporting Elements (High Resolution)',

  // Optimised Images (Section 4)
  H: 'Mobile Ready Hero Image (MRHI)',
  U: 'Optimised Hero Images',
  E: 'Product Image 360°/3D',
  '3DR': '3D Rendered',

  // Secondary Images (Section 5)
  T: 'Content/Texture',
  F: 'Detail/Technology',
  M: 'Montage/Composition',
  K: 'Social Media',
  N: 'Application',
  R: 'Ambience/Mood',
  Q: 'Size comparison',
  L2: 'Nutritional Label',
  L4: 'Ingredients',
  L5: 'Nutritional/Ingredients combined',
  L7: 'Certification Seals/Claims',
  L8: 'Preparation Instructions',
  L9: 'Petfood Feeding Instructions/Ingredients',
  L10: 'Safe Handling Instructions',
  S: 'Sidekick Images',
  L11: 'Drug Fact Label',
  L12: 'Supplement Fact Label',
  L13: 'Lighting Fact Label',
  J: 'Sustainability',

  // Technical Images (Section 6)
  L1: 'Full Flat',
  L3: 'Linear barcode',
  L6: '2D barcode',
  G: 'Pharmaceutical Drugs/Medical Devices',
};

const IMAGE_TYPE_OPTIONS = Object.entries(IMAGE_TYPE).map(([key, value]) => ({
  label: value,
  value: key,
}));

// Media Type - Based on GS1 IMAGE_TYPE_MAPPING values
const MEDIA_TYPE = {
  // Primary Images (Section 3)
  PRODUCT_IMAGE_WEB_PRIMARY: 'Product Image (web) primary image',
  PRODUCT_IMAGE_WITH_SUPPORTING_ELEMENTS_WEB: 'Product Image with Supporting Elements (web)',
  PRODUCT_IMAGE_HIGH_RESOLUTION: 'Product Image (High Resolution)',
  PRODUCT_IMAGE_WITH_SUPPORTING_ELEMENTS_HIGH_RES:
    'Product Image with Supporting Elements (High Resolution)',

  // Optimised Images (Section 4)
  MOBILE_READY_HERO_IMAGE: 'Mobile Ready Hero Image (MRHI)',
  OPTIMISED_HERO_IMAGES: 'Optimised Hero Images',
  PRODUCT_IMAGE_360_3D: 'Product Image 360°/3D',
  THREE_D_RENDERED: '3D Rendered',

  // Secondary Images (Section 5)
  CONTENT_TEXTURE: 'Content/Texture',
  DETAIL_TECHNOLOGY: 'Detail/Technology',
  MONTAGE_COMPOSITION: 'Montage/Composition',
  SOCIAL_MEDIA: 'Social Media',
  APPLICATION: 'Application',
  AMBIENCE_MOOD: 'Ambience/Mood',
  SIZE_COMPARISON: 'Size comparison',
  NUTRITIONAL_LABEL: 'Nutritional Label',
  INGREDIENTS: 'Ingredients',
  NUTRITIONAL_INGREDIENTS_COMBINED: 'Nutritional/Ingredients combined',
  CERTIFICATION_SEALS_CLAIMS: 'Certification Seals/Claims',
  PREPARATION_INSTRUCTIONS: 'Preparation Instructions',
  PETFOOD_FEEDING_INSTRUCTIONS: 'Petfood Feeding Instructions/Ingredients',
  SAFE_HANDLING_INSTRUCTIONS: 'Safe Handling Instructions',
  SIDEKICK_IMAGES: 'Sidekick Images',
  DRUG_FACT_LABEL: 'Drug Fact Label',
  SUPPLEMENT_FACT_LABEL: 'Supplement Fact Label',
  LIGHTING_FACT_LABEL: 'Lighting Fact Label',
  SUSTAINABILITY: 'Sustainability',

  // Technical Images (Section 6)
  FULL_FLAT: 'Full Flat',
  LINEAR_BARCODE: 'Linear barcode',
  TWO_D_BARCODE: '2D barcode',
  PHARMACEUTICAL_DRUGS_MEDICAL_DEVICES: 'Pharmaceutical Drugs/Medical Devices',
};

const MEDIA_TYPE_OPTIONS = Object.entries(MEDIA_TYPE).map(([, value]) => ({
  label: value,
  value,
}));

// Product State - Based on GS1 STATE_MAPPING
const PRODUCT_STATE = {
  OUT_OF_PACKAGING: 'out_of_packaging',
  IN_PACKAGING: 'in_packaging',
  CLOSED_CASE: 'closed_case',
  INNER_PACK: 'inner_pack',
  RAW_OR_UNCOOKED: 'raw_or_uncooked',
  PREPARED: 'prepared',
  PLATED: 'plated',
  STYLED: 'styled',
  STAGED: 'staged',
  HELD: 'held',
  WORN: 'worn',
  USED: 'used',
  FAMILY: 'family',
  OPEN_CASE: 'open_case',
  PALLET_DISPLAY: 'pallet_display',
  FORMED: 'formed',
};

const PRODUCT_STATE_OPTIONS = Object.entries(PRODUCT_STATE).map(([key, value]) => ({
  label: key.charAt(0) + key.slice(1).toLowerCase().replace(/_/g, ' '),
  value,
}));

// Product Facing - Based on GS1 FACING_MAPPING
const PRODUCT_FACING = {
  NOT_APPLICABLE: 'not_applicable',
  FRONT: 'front',
  LEFT: 'left',
  TOP: 'top',
  BACK: 'back',
  RIGHT: 'right',
  BOTTOM: 'bottom',
};

const PRODUCT_FACING_OPTIONS = Object.entries(PRODUCT_FACING).map(([key, value]) => ({
  label: key.charAt(0) + key.slice(1).toLowerCase().replace(/_/g, ' '),
  value,
}));

export {
  IMAGE_TYPE,
  IMAGE_TYPE_OPTIONS,
  MEDIA_TYPE,
  MEDIA_TYPE_OPTIONS,
  PRODUCT_STATE,
  PRODUCT_STATE_OPTIONS,
  PRODUCT_FACING,
  PRODUCT_FACING_OPTIONS,
};
